import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../../shared/components/Nav/Navbar';
import Footer from '../../../shared/components/Nav/Footer';

const DefaultLayout = () => {
  return (
    <div
      className="aurora-shell min-h-screen w-full overflow-x-hidden bg-surface-default text-text-primary"
    >
      <Navbar />

      <main className="aurora-main relative w-full px-0 pb-24 pt-6">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default DefaultLayout;
